import React from 'react'

import { MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import BottomNavbar from "../../componetes/navbar";
import BackButton from './retoceder'
import AppTutorial from "../../componentes/tutorial/AppTutorial";

interface Props{
    children: React.ReactNode
}
const Layaout:React.FC<Props> = ({children}) =>{
    return<>
    <AppTutorial />
    <BackButton />
    <MDBContainer>
        <MDBRow center>
            <MDBCol center lg={12} md={12} sm={12} xl={12} xs={12}>
               {children} 
            </MDBCol>
        </MDBRow>
    </MDBContainer>
        <BottomNavbar />
    </>
}
export default Layaout